import { CircularLoader } from '@modules/common/components/CircularLoader';
import useFeedbackListStore from '@modules/feedback/store/useFeedbackListStore';
import { useSavedFeedbackListStore } from '@modules/savedFeedbackList/store/useSavedFeedbackListStore';
import { IconButton, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { RemoveFromCollectionIcon } from '../RemoveFromCollectionIcon/RemoveFromCollectionIcon';
import { SaveFeedbackContext } from '../SaveFeedbackContext';
import { useRemoveFeedbackFromCollection } from '../hooks';

interface RemoveFromCollectionIconButtonProps {
  feedbackID: string;
  iconColor?: string;
}

export const RemoveFromCollectionIconButton = ({
  feedbackID,
  iconColor,
}: RemoveFromCollectionIconButtonProps) => {
  const {
    renderedInsideCollectionID,
    renderedInsideCollectionEQL,
    renderedInsideCollectionEditToken,
    renderedInsideCollectionTitle,
    renderedInsideCollectionViewToken,
  } = useFeedbackListStore();

  const { savedItemsMap } = useSavedFeedbackListStore();
  const contextData = useContext(SaveFeedbackContext);

  const isSnippetPartOfCollection = savedItemsMap[
    feedbackID
  ]?.snippetMetadataV2?.find(
    (snippetMetadata) =>
      snippetMetadata.location.keywordSummary?.labelID ===
        contextData?.labelID &&
      snippetMetadata.location.keywordSummary?.msgIdx ===
        contextData?.summaryIndex,
  );

  const { removeFeedbackFromCollection, isLoading } =
    useRemoveFeedbackFromCollection({
      collectionID: renderedInsideCollectionID ?? '',
      feedbackID,
      collectionEQL: renderedInsideCollectionEQL ?? '',
      collectionEditToken: renderedInsideCollectionEditToken,
      collectionTitle: renderedInsideCollectionTitle ?? '',
      collectionViewToken: renderedInsideCollectionViewToken,
      shouldShowOpenCollectionLink: false,
    });

  if (
    !renderedInsideCollectionEditToken ||
    (contextData?.snippetID && !isSnippetPartOfCollection)
  ) {
    return null;
  }

  return (
    <Tooltip title="Remove from this Collection">
      <IconButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          removeFeedbackFromCollection();
        }}
        disabled={isLoading}
      >
        {isLoading ? (
          <CircularLoader size={24} />
        ) : (
          <RemoveFromCollectionIcon
            sx={{ color: iconColor ?? 'primary.main' }}
          />
        )}
      </IconButton>
    </Tooltip>
  );
};
